import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  nameField: {
    width: '100%',
    '& .MuiOutlinedInput-root': {
      borderRadius: 9999,
      backgroundColor: theme.palette.common.white,
      minHeight: 44,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.divider,
      borderRadius: 9999,
    },
    '& fieldset': {
      borderRadius: 9999,
    },
    '& .MuiOutlinedInput-input': {
      padding: theme.spacing(1.25, 1.5),
      fontSize: '0.875rem',
    },
    '& .MuiInputLabel-outlined': {
      fontSize: '0.875rem',
    },
  },
}))

const EditGroupNameModal = ({
  open,
  setOpen,
  channelName = '',
  setChannelName,
  channel,
}) => {
  const classes = useStyles()

  const handleUpdateName = () => {
    channel.update({ name: channelName.trim() })
    setOpen(false)
  }

  return (
    <Dialog fullWidth maxWidth="xs" onClose={() => setOpen(false)} open={open}>
      <DialogTitle>Update Name</DialogTitle>
      <DialogContent>
        <TextField
          className={classes.nameField}
          fullWidth
          inputProps={{ maxLength: 30 }}
          label="Group Name"
          onChange={e => setChannelName(e.target.value)}
          value={channelName}
          variant="outlined"
        />
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={() => setOpen(false)}>
          Cancel
        </Button>
        <Button color="primary" onClick={handleUpdateName} variant="contained">
          Update Name
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default EditGroupNameModal
